// extracted by mini-css-extract-plugin
module.exports = {"stubInput":"AutoCompletionStub_stubInput__vKlDQ"};